import React from 'react';
import {MasterLayout} from 'components/layouts';
import {NewsDetail} from 'components/news';
import title from 'constants/TitlePages.js';

import {asyncConnect} from 'redux-connect';
import CONFIG from 'base/constants/config';
import {Articles} from 'api';

@asyncConnect([
  {
    key: 'article',
    promise: ({
      match: {
        params: {
          id
        }
      },
      store: {
        dispatch
      },
      helpers
    }) => {
      return Articles.actions.details.request({id}).then(response => {
        if (response.data) {
          let description = response.data.content.replace(/<(.|\n)*?>/g, '');
          dispatch({
            type: 'SEO_INFO',
            data: {
              title: response.data.title,
              // TODO: using limit words by charactor
              description: description.substring(0, 300),

              // TODO: Use custom SEO image
              image: `${CONFIG.UploadImageURL}/03708aed6ad48b41b843785cf1d0d3de.jpg`
            }
          });

          return Promise.resolve(response.data);
        }
      });
    }
  }
])
class NewsDetailPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = this.props.article ? this.props.article.title : 'Vitrade';
    setTimeout(() => window.scrollTo(0, 0), 100);
  }

  render() {
    return (
      <MasterLayout hasBreadcrumb={true} classBreadcrumb='news-breadcrumb' pageClass='news-detail-page'>
        {this.props.article && <NewsDetail article={this.props.article}/>}
      </MasterLayout>
    );
  }
}

export default NewsDetailPage;



// WEBPACK FOOTER //
// ./pages/news/NewsDetailPage.jsx